import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from './PageContext';
import PageDropdown from './PageDropdownCopy.jsx';
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import isNullOrUndefined from '../functions/isNullOrUndefined';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const EditUserModal = () => {
    // get context from parent
    const {
        editUserModal,
        setEditUserModal,
        editUserRow,
        getUsersRefresh,
        snackbarAlert,
        roleFilterData,
        editRoleList,
        roleRequestData
    } = useContext(PageContext);
    // initialize http context 
    const {
        PUT,
    } = useContext(HttpContext);

    // set state
    const [status, setStatus] = useState('');
    const [statusList, setStatusList] = useState(['Active', 'Inactive']);
    const [userId, setUserId] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [role, setRole] = useState('');
    // use ref to determine initial render
    const initialRender = useRef(true);


    // use api to edit user's cognito information
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            // transform role according to object
            let newRole = null;
            if (!isNullOrUndefined(roleRequestData[role])) {
                newRole = roleRequestData[role];
            }
            else {
                snackbarAlert(true, 'Error: Invalid role selection.', 'error');
                reject();
                return;
            }
            // make request 
            let response;
            console.log('PARAMS: ', { user: userId, status: status, role: role, oldRole: editUserRow['custom:Role'] });
            PUT('/user/inv/edituser', {
                user: userId,
                status: status,
                role: newRole,
                oldRole: editUserRow['custom:Role']
            }).then(res => {
                console.log(res);
                response = res;
                // show snackbar on success
                snackbarAlert(true, `Updated ${userId}`, 'success');
                // hide modal on success
                setEditUserModal(editUserModal => editUserModal = false);
                // refresh data on page
                return getUsersRefresh();
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response);
            }).catch(err => {
                console.log(err);
                // if 499 error is thrown show message that user limit is reached
                if (err == 'Error: Request failed with status code 499') {
                    snackbarAlert(true, 'Error: Active user limit reached.', 'error');
                }
                // show snackbar on error
                else {
                    snackbarAlert(true, 'Error updating user: ' + userId, 'error');
                }
                // reject on error 
                reject(err);
            });
        });
    }

    // useEffect to run when editUserRow is changed in parent
    useEffect(() => {
        // do not assign to state variables on initial render
        if (initialRender.current == true) {
            initialRender.current = false;
        }
        // assign to state variables from editUserRow object
        else {
            if (editUserRow['custom:Active'] == 1) {
                setStatus(status => status = 'Active');
            }
            else {
                setStatus(status => status = 'Inactive');
            }
            // set userId
            if (!isNullOrUndefined(editUserRow['username'])) {
                setUserId(userId => userId = editUserRow['username']);
            }
            else {
                setUserId(userId => userId = null);
            }
            // set first and last name 
            if (!isNullOrUndefined(editUserRow['name'])) {
                setFirstName(firstName => firstName = editUserRow['name'].split(', ')[1]);
                setLastName(lastName => lastName = editUserRow['name'].split(', ')[0]);
            }
            else {
                setFirstName(firstName => firstName = null);
                setLastName(lastName => lastName = null);
            }
            //conditional for role descrp change
            if (!isNullOrUndefined(editUserRow['custom:Role'])) {
                setRole(role => role = roleFilterData[editUserRow['custom:Role']]);
                // editUserRow['custom:Role'] == 'DataTechnician' ? 'Rebate Data Technician'
                // : editUserRow['custom:Role'] == 'Administrator' ? 'Rebate Administrator' 
                // : editUserRow['custom:Role']);
            }
            else {
                setRole(role => role = '');
            }
        }
    }, [editUserRow]);

    const settings = {}
    return (
        <PageContext.Provider value={settings}>
            <>
                <CCOffcanvas className="rebate-summary-modal"
                    show={editUserModal}
                    title={`Edit ${firstName || ''} ${lastName || ''}`}
                    onCanvasClose={() => setEditUserModal(editUserModal => editUserModal = false)}
                    bodyCssClassName="offcanvas-body bg-white p-3"
                    offCanvasClassName="offcanvas-parent-card-30"
                >
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex flex-column flex-grow-1 overflow-scroll">

                            <div className="d-flex align-items-center justify-content-start">
                                <PageDropdown tag='Status' value={status} setValue={setStatus} list={statusList} topAlignTypography={true} width={'100%'}/>
                            </div>
                            <div className="d-flex align-items-center justify-content-start mt-3">
                                <PageDropdown tag='Role' value={role} setValue={setRole} list={editRoleList} topAlignTypography={true} width={'100%'}/>
                            </div>
                        </div>
                        <div
                             className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                        >
                            <ButtonComponent tag={"Cancel"}
                            border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                            onButtonClick={() => setEditUserModal(editUserModal => editUserModal = false)}
                        />
                            <ApiRequestButton onButtonClick={onSubmitClick} />
                        </div>
                    </div>
                </CCOffcanvas>




            </>
        </PageContext.Provider>
    );
}

export default EditUserModal;